import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';

import styles from './styles';

const responsiveStyles = theme => ({
  mobileWhiteBoxContainer: {
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '20px',
      margin: '20px 10px 20px 10px',
    },
  },
  tabletWhiteBoxContainer: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: 'auto',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '28px',
      margin: '20px',
    },
  },
  whiteBoxContainer: {
    width: '90%',
    maxWidth: 1320,
    minWidth: 1320,
    backgroundColor: '#fff',
    borderRadius: 0,
    padding: 40,
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    marginBottom: 40,
    overflowWrap: 'break-word',
    [theme.breakpoints.down('lg')]: {
      minWidth: 'auto',
      maxWidth: '100%',
      width: '90%',
    },
    [theme.breakpoints.down('xs')]: { padding: 20 },
  },

  mobileStepBoxContainer: {
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '16px',
      margin: '20px 10px 20px 10px',
      fontSize: '20px',
    },
  },
  tabletStepBoxContainer: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: 'auto',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '18px',
      margin: '20px',
      fontSize: '22px',
    },
  },
  stepBoxContainer: {
    width: '90%',
    maxWidth: 1320,
    minWidth: 1320,
    backgroundColor: '#fff',
    borderRadius: 0,
    fontSize: 24,
    padding: 20,
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    marginBottom: 40,
    overflowWrap: 'break-word',
    [theme.breakpoints.down('lg')]: {
      minWidth: 'auto',
      maxWidth: '100%',
      width: '90%',
    },
    [theme.breakpoints.down('xs')]: { padding: 20 },
  },

  mobileStepBoxFullWidthContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '96%',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '20px',
      margin: '20px 10px 20px 10px',
      backgroundColor: '#fff',
      borderRadius: 0,
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      marginBottom: 40,
      overflowWrap: 'break-word',
    },
  },

  tabletStepBoxFullWidthContainer: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '96%',
      maxWidth: '100%',
      minWidth: 'auto',
      padding: '28px',
      margin: '20px',
      backgroundColor: '#fff',
      borderRadius: 0,
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      marginBottom: 40,
      overflowWrap: 'break-word',
    },
  },

  selectionWrapper: {
    width: '90%',
    maxWidth: 1320,
    minWidth: 1320,
    margin: '0 0 -80px 0',
    backgroundColor: '#F8F8FA',
    marginBottom: 40,
    overflowWrap: 'break-word',
    [theme.breakpoints.down('lg')]: {
      minWidth: 'auto',
      width: '90%',
    },
  },

  mobileSelectionWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      margin: '0',
    },
  },
  tabletSelectionWrapper: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
      margin: '0',
    },
  },
  mobileStartControlsRow: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: '0 16px',
      gap: '0',
    },
  },
  tabletStartControlsRow: {
    [theme.breakpoints.between('sm', 'md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: '0 24px',
      gap: '0',
    },
  },
  mobileDropdownWrapper: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      maxWidth: '100%',
      width: '100%',
      margin: '0 0 20px 0',
    },
  },
  tabletDropdownWrapper: {
    [theme.breakpoints.between('sm', 'md')]: {
      minWidth: '100%',
      maxWidth: '100%',
      width: '100%',
      margin: '0 0 20px 0',
    },
  },
  mobileStartFormControl: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100% !important',
      maxWidth: '100% !important',
      width: '100% !important',
      boxSizing: 'border-box',
    },
  },
  tabletStartFormControl: {
    [theme.breakpoints.between('sm', 'md')]: {
      minWidth: '100% !important',
      maxWidth: '100% !important',
      width: '100% !important',
      boxSizing: 'border-box',
    },
  },
  mobileEdgeDiv: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      maxWidth: '100%',
      marginRight: 0,
    },
  },
  tabletEdgeDiv: {
    [theme.breakpoints.between('sm', 'md')]: {
      minWidth: '100%',
      maxWidth: '100%',
      marginRight: 0,
    },
  },
});

const customStyles = theme => ({
  underlineWhite: {
    '&:before': { borderBottomColor: '#fff !important' },
    '&:hover:not(.Mui-disabled):before': { borderBottomColor: '#fff !important' },
    '&:after': { borderBottomColor: '#fff !important' },
    color: '#fff',
  },
  whiteInputLabel: {
    color: '#fff !important',
    '&.Mui-focused': { color: '#fff !important' },
  },
  iconWhite: { fill: '#fff', color: '#fff' },
  moreInformations: {
    color: '#718FB7',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': { color: '#5E4B9A' },
  },
  whiteBoxContainer: {
    width: '90%',
    maxWidth: '1320px',
    minWidth: '1320px',
    backgroundColor: '#fff',
    borderRadius: 0,
    padding: '40px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    marginBottom: '40px',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('xs')]: { padding: '20px' },
  },
  titleUnderline: {
    border: 0,
    borderBottom: '1px solid #0F145C',
    width: '45%',
    margin: '10px 0 20px',
  },
  stepBoxContainer: {
    width: '90%',
    maxWidth: '1320px',
    minWidth: '1320px',
    backgroundColor: '#fff',
    borderRadius: 0,
    fontSize: '24px',
    padding: '20px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    marginBottom: '40px',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('xs')]: { padding: '20px' },
  },
  selectionWrapper: {
    width: '90%',
    maxWidth: '1320px',
    minWidth: '1320px',
    margin: '0 0 -80px 0',
    backgroundColor: '#F8F8FA',
    marginBottom: '40px',
    overflowWrap: 'break-word',
  },
  formControlCommon: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
      border: '1px solid #CDD0D4',
      borderRadius: 4,
    },
    '& .MuiSelect-select': { padding: '12px', color: '#0F145C', fontSize: '18px' },
  },
  menuItemCommon: { whiteSpace: 'normal' },
  welcomeHeader: {
    fontSize: '27px',
    fontWeight: 700,
    lineHeight: 1.2,
    margin: 0,
    overflowWrap: 'break-word',
  },
});

const mergedStyles = theme => ({
  ...styles(theme),
  ...customStyles(theme),
  ...responsiveStyles(theme),
});

class Start extends Component {
  constructor() {
    super();
    this.state = {
      institution: [
        { id: 1, value: 'University or Large Hospital' },
        { id: 2, value: 'Smaller or Community Hospital' },
        { id: 3, value: 'Radiology Imaging Center' },
        { id: 4, value: 'Orthopedic or Chiro Center' },
        { id: 5, value: 'Small VET Clinic' },
        { id: 6, value: 'Large VET Clinic' },
      ],
      region: [
        { id: 1, value: 'Europe, North America, Japan, Australia and Oceania' },
        { id: 2, value: 'Rest of Asia, South America, Africa' },
      ],
      isMobile: window.innerWidth <= 600,
      isTablet: window.innerWidth > 600 && window.innerWidth <= 1280,
    };
  }

  handleResize = () => {
    const width = window.innerWidth;
    const isMobile = width <= 600;
    const isTablet = width > 600 && width <= 1280;
    if (isMobile !== this.state.isMobile || isTablet !== this.state.isTablet) {
      this.setState({ isMobile, isTablet });
    }
  };

  componentWillMount() {
    this.getSessionID();
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  getSessionID = () => {
    const sessionID = this.props.match.url.substr(1);
    this.props.getSessionID(sessionID);
  };

  updateInstitution = (event) => {
    this.props.changeInstitution(event.target.value);
  };
  updateRegion = (event) => {
    this.props.changeRegion(event.target.value);
  };

  getInstitution() {
    return this.state.institution.map(ins => (
      <MenuItem
        className={this.props.classes.resultMenuItem}
        key={ins.id}
        value={ins.value}
      >
        {ins.value}
      </MenuItem>
    ));
  }

  getRegion() {
    return this.state.region.map(reg => (
      <MenuItem
        className={this.props.classes.resultMenuItem}
        key={reg.id}
        value={reg.value}
      >
        {reg.value}
      </MenuItem>
    ));
  }

  render() {
    const { classes, isEDGE, selectedIns, selectedReg } = this.props;
    const { isMobile, isTablet } = this.state;

    const whiteBoxClass = [
      classes.whiteBoxContainer,
      isMobile && classes.mobileWhiteBoxContainer,
      isTablet && classes.tabletWhiteBoxContainer,
    ].filter(Boolean).join(' ');

    const stepBoxClass = [
      classes.stepBoxContainer,
      isMobile && classes.mobileStepBoxContainer,
      isTablet && classes.tabletStepBoxContainer,
      isMobile && classes.mobileStepBoxFullWidthContainer,
      isTablet && classes.tabletStepBoxFullWidthContainer,
    ].filter(Boolean).join(' ');

    const selectionWrapperClass = [
      classes.selectionWrapper,
      isMobile && classes.mobileSelectionWrapper,
      isTablet && classes.tabletSelectionWrapper,
    ].filter(Boolean).join(' ');

    const startControlsRowClass = [
      classes.startControlsRow,
      isMobile && classes.mobileStartControlsRow,
      isTablet && classes.tabletStartControlsRow,
    ].filter(Boolean).join(' ');

    const dropdownWrapperClass = [
      classes.dropdownWrapper,
      isMobile && classes.mobileDropdownWrapper,
      isTablet && classes.tabletDropdownWrapper,
    ].filter(Boolean).join(' ');

    const startFormControlClass = [
      classes.startFormControl,
      classes.hideInternalLabel,
      classes.resultFormControlNoMB,
      isMobile && classes.mobileStartFormControl,
      isTablet && classes.tabletStartFormControl,
    ].filter(Boolean).join(' ');

    const regFormControlClass = [
      classes.resultFormControl,
      classes.hideInternalLabel,
      classes.resultFormControlNoMB,
      isMobile && classes.mobileStartFormControl,
      isTablet && classes.tabletStartFormControl,
    ].filter(Boolean).join(' ');

    const edgeDivClass = [
      classes.edgeDiv,
      classes.hideInternalLabel,
      isMobile && classes.mobileEdgeDiv,
      isTablet && classes.tabletEdgeDiv,
    ].filter(Boolean).join(' ');

    const welcomeHeaderStyle = isMobile
      ? { color: '#0F145C', fontSize: '20px', fontWeight: 700, lineHeight: 1.2, margin: 0 }
      : { color: '#0F145C' };
    const paragraphStyle = isMobile
      ? { textAlign: 'justify', fontSize: '15px', lineHeight: 1.5, marginBottom: '15px', color: '#0F145C' }
      : { textAlign: 'justify', fontSize: '18px', lineHeight: 1.5, marginBottom: '20px', color: '#0F145C' };
    const moreInfoStyle = isMobile
      ? { textAlign: 'justify', fontSize: '15px', lineHeight: 1.5, margin: 0 }
      : { textAlign: 'justify', fontSize: '18px', lineHeight: 1.5, margin: 0 };
    const stepBoxTextStyle = isMobile
      ? { margin: 0, fontSize: '16px', color: '#0F145C' }
      : { margin: 0, fontSize: '24px', color: '#0F145C' };
    const dropdownHeaderStyle = isMobile
      ? { fontSize: '15px', fontWeight: 'bold', color: '#0F145C', marginBottom: '5px', padding: 0 }
      : {};

    return (
      <Grid
        container
        item
        style={{ backgroundColor: '#F8F8FA', padding: '40px 0 0 0', overflowWrap: 'break-word' }}
        spacing={0}
        direction="column"
        justify="center"
        alignItems="center"
        id="startContainer"
      >
        <Grid container direction="column" className={whiteBoxClass}>
          <p className={classes.welcomeHeader} style={welcomeHeaderStyle}>
            <span style={welcomeHeaderStyle}>Welcome to the PACS Sizing Calculator</span>
          </p>
          <hr className={classes.titleUnderline} />

          <p style={paragraphStyle}>
            Our powerful tool takes the guesswork out of PACS planning by helping you pinpoint the optimal storage capacity for your Picture Archiving and Communication System (PACS). Avoid the costly pitfalls of over- or under-provisioning.
          </p>
          <p style={paragraphStyle}>
            All too often, PACS users and administrators invest in systems that are either oversized or undersized, which leads to slow performance and frustration. Our solution ensures you get the storage you need for your image data – maximising efficiency, performance and return on investment.
          </p>
          <p style={moreInfoStyle}>
            <a className={classes.moreInformations} style={{ fontSize: isMobile ? '15px' : undefined }} onClick={this.props.changeDialogState}>
              More Information
            </a>
          </p>
        </Grid>

        <Grid container direction="row" className={stepBoxClass}>
          <p style={stepBoxTextStyle}>
            <strong>Step&nbsp;1:</strong> Please select the type of imaging center and geographical
            region.
          </p>
        </Grid>

        <Grid container className={selectionWrapperClass}>
          <div className={startControlsRowClass}>
            <div className={dropdownWrapperClass}>
              <Typography className={classes.dropdownHeader} style={dropdownHeaderStyle}>
                Type of Imaging Center
              </Typography>
              {isEDGE ? (
                <div className={edgeDivClass} id="startInstitution">
                  <label className={classes.edgeWhiteLabel} style={dropdownHeaderStyle}>
                    Type of Imaging Center
                  </label>
                  <select
                    className={classes.edgeWhiteInput}
                    value={selectedIns}
                    onChange={this.updateInstitution}
                    style={isMobile ? { fontSize: '15px' } : {}}
                  >
                    {this.state.institution.map(ins => (
                      <option className={classes.resultMenuItem} key={ins.id} value={ins.value}>
                        {ins.value}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <FormControl className={startFormControlClass} id="ins-select" fullWidth>
                  <InputLabel classes={{ root: classes.whiteInputLabel }} style={dropdownHeaderStyle}>
                    Type of Imaging Center
                  </InputLabel>
                  <Select
                    value={selectedIns}
                    onChange={this.updateInstitution}
                    input={
                      <Input
                        name="institution"
                        id="institution-helper"
                        classes={{ underline: classes.whiteUnderline, input: classes.whiteInput }}
                        style={isMobile ? { fontSize: '15px' } : {}}
                      />
                    }
                    classes={{ icon: classes.whiteIcon }}
                    style={isMobile ? { fontSize: '15px' } : {}}
                  >
                    {this.getInstitution()}
                  </Select>
                </FormControl>
              )}
            </div>

            <div className={dropdownWrapperClass}>
              <Typography className={classes.dropdownHeader} style={dropdownHeaderStyle}>
                Geographical Region
              </Typography>
              {isEDGE ? (
                <div className={edgeDivClass} id="startRegion">
                  <label className={classes.edgeWhiteLabel} style={dropdownHeaderStyle}>
                    Geographical Region
                  </label>
                  <select
                    className={classes.edgeWhiteInput}
                    value={selectedReg}
                    onChange={this.updateRegion}
                    style={isMobile ? { fontSize: '15px' } : {}}
                  >
                    {this.state.region.map(reg => (
                      <option className={classes.resultMenuItem} key={reg.id} value={reg.value}>
                        {reg.value}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <FormControl className={regFormControlClass} id="reg-select" fullWidth>
                  <InputLabel classes={{ root: classes.whiteInputLabel }} style={dropdownHeaderStyle}>
                    Geographical Region
                  </InputLabel>
                  <Select
                    value={selectedReg}
                    onChange={this.updateRegion}
                    input={
                      <Input
                        name="region"
                        id="region-helper"
                        classes={{ underline: classes.whiteUnderline, input: classes.whiteInput }}
                        style={isMobile ? { fontSize: '15px' } : {}}
                      />
                    }
                    classes={{ icon: classes.whiteIcon }}
                    style={isMobile ? { fontSize: '15px' } : {}}
                  >
                    {this.getRegion()}
                  </Select>
                </FormControl>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

Start.propTypes = {
  classes: PropTypes.object.isRequired,
  isEDGE: PropTypes.bool.isRequired,
  selectedIns: PropTypes.string,
  selectedReg: PropTypes.string,
  changeInstitution: PropTypes.func.isRequired,
  changeRegion: PropTypes.func.isRequired,
  getSessionID: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  changeDialogState: PropTypes.func,
};

export default withStyles(mergedStyles)(Start);


// WEBPACK FOOTER //
// ./src/Start.js